import {createSelector} from 'redux-orm';
import orm from './orm';

export const uploadedFiles = createSelector(orm.UploadedFile);

export const selectOrganizations = createSelector(
  orm,
  session => session.Organization.all().orderBy('render_name').toRefArray(),
);
